"use client";
import { t as T } from "../dist-CRiumotD.js";
import { jsx } from "react/jsx-runtime";
var skeletonStyles = T({
	base: "animate-pulse rounded-md bg-secondary",
	variants: {
		shape: {
			rectangle: "rounded-md",
			circle: "rounded-full",
			text: "rounded-md h-4"
		},
		size: {
			xs: "h-3",
			sm: "h-4",
			md: "h-6",
			lg: "h-8",
			xl: "h-10"
		}
	},
	defaultVariants: { shape: "rectangle" }
}), Skeleton = ({ className: e, shape: r, size: i, width: a, height: o, style: s,...c }) => {
	let l = {
		...s,
		...a && { width: typeof a == "number" ? `${a}px` : a },
		...o && { height: typeof o == "number" ? `${o}px` : o }
	};
	return /* @__PURE__ */ jsx("div", {
		className: skeletonStyles({
			shape: r,
			size: i,
			className: e
		}),
		style: l,
		...c
	});
};
export { Skeleton, skeletonStyles };
